import { Component, HostListener, Renderer2, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationStart } from '@angular/router';
import pageSettings from './config/page-settings';
import { TranslationLoaderService } from './service/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ConnectBackendService } from './service/connect-backend.service';
import { navigationEnglish } from './navigation/i18n/en';
import { navigationThai } from './navigation/i18n/th';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {

  constructor(
    private titleService: Title, private router: Router, private renderer: Renderer2,
    private translate: TranslationLoaderService,
    private _translateService: TranslateService,
    public authService: ConnectBackendService,
  ) {
    this._translateService.addLangs(['en', 'th']);
    this.translate.loadTranslations(navigationThai, navigationEnglish);
    this._translateService.setDefaultLang('th');

    router.events.subscribe((e) => {
      if (e instanceof NavigationStart) {
        if (window.innerWidth <= 1024) {
          this.pageSettings.pageMobileSidebarToggled = false;
        }
      }
    });
    const regex = /(?:^|\W)27.254.171.187(?:$|\W)/gm;
    if (regex.test(window.location.href)) {
      window.location.href = 'http://www.jpos2.com/jpos2021';
    }
  }

  pageSettings;

  // window scroll
  pageHasScroll;

  ngOnInit() {
    // page settings
    //console.log(window.innerWidth)
    this.pageSettings = pageSettings;
    if (this.authService.isLoggedIn !== true) {
      this.router.navigate(['']);
    }
  }
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    const doc = document.documentElement;
    const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (top > 0) {
      this.pageHasScroll = true;
    } else {
      this.pageHasScroll = false;
    }
  }

  // set page minified
  onToggleSidebarMinified(val: boolean): void {
    if (this.pageSettings.pageSidebarMinified) {
      this.pageSettings.pageSidebarMinified = false;
    } else {
      this.pageSettings.pageSidebarMinified = true;
    }
  }

  // set page right collapse
  onToggleSidebarRight(val: boolean): void {
    if (this.pageSettings.pageSidebarRightCollapsed) {
      this.pageSettings.pageSidebarRightCollapsed = false;
    } else {
      this.pageSettings.pageSidebarRightCollapsed = true;
    }
  }

  // hide mobile sidebar
  onHideMobileSidebar(val: boolean): void {
    if (this.pageSettings.pageMobileSidebarToggled) {
      if (this.pageSettings.pageMobileSidebarFirstClicked) {
        this.pageSettings.pageMobileSidebarFirstClicked = false;
      } else {
        this.pageSettings.pageMobileSidebarToggled = false;
      }
    }
  }

  // toggle mobile sidebar
  onToggleMobileSidebar(val: boolean): void {
    if (this.pageSettings.pageMobileSidebarToggled) {
      this.pageSettings.pageMobileSidebarToggled = false;
    } else {
      this.pageSettings.pageMobileSidebarToggled = true;
      this.pageSettings.pageMobileSidebarFirstClicked = true;
    }
  }


  // hide right mobile sidebar
  onHideMobileRightSidebar(val: boolean): void {
    if (this.pageSettings.pageMobileRightSidebarToggled) {
      if (this.pageSettings.pageMobileRightSidebarFirstClicked) {
        this.pageSettings.pageMobileRightSidebarFirstClicked = false;
      } else {
        this.pageSettings.pageMobileRightSidebarToggled = true;
        this.pageSettings.pageMobileRightSidebarFirstClicked = true;
      }
    }
  }

  // toggle right mobile sidebar
  onToggleMobileRightSidebar(val: boolean): void {
    if (this.pageSettings.pageMobileRightSidebarToggled) {
      this.pageSettings.pageMobileRightSidebarToggled = false;
    } else {
      this.pageSettings.pageMobileRightSidebarToggled = true;
      this.pageSettings.pageMobileRightSidebarFirstClicked = true;
    }
  }

}
